import React from "react";
import PanelHeading from "./PanelHeading";
// import PanelBody from "./PanelBody";
import { PanelBodyContainer } from "./PanelBodyPOC";
import { itemType } from "../types";
import PropTypes from "prop-types";
import userStore from "data/userStore";

class ValidationTree extends React.Component {
    render() {
        const {
            toggleFilter,
            filters,
            item,
            ctx,
        } = this.props;
        const illegalLabel = item
            ? userStore.getIllegalLabel(item.entityKey)
            : null;
        return (<div className="validation-panel">
            <PanelHeading {...filters}
                          illegalLabel={illegalLabel}
                          onFilterClick={toggleFilter} />
            {item && <PanelBodyContainer item={item}
                                         ctx={ctx}
            />}
        </div>);
    }
}

ValidationTree.propTypes = {
    ctx: PropTypes.string.isRequired,
    item: itemType,
    filters: PropTypes.shape({
        illegal: PropTypes.bool.isRequired,
        warning: PropTypes.bool.isRequired,
        ok: PropTypes.bool.isRequired,
        all: PropTypes.bool.isRequired,
    }).isRequired,
    toggleFilter: PropTypes.func.isRequired,
};

export default ValidationTree;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/validationtree/components/ValidationTree.js